<template>
  <div class="container">
    <div class="templates" v-if="selectTemplateGroup.length && !loaderTemplates">
      <div v-for="(templates, index) in selectTemplateGroup" :key="templates.name">
        <button class="content" @click="openModal(templates, index)">
          <div
            :id="`content-template-${index}-${templates.group_code}`"
            class="content-template"
          >
            <img :src="`${imageURLTemplates}${templates.group_code}.png`" />
          </div>

          <p>{{ templates.group_name }}</p>
        </button>
      </div>
    </div>

    <div v-else-if="queryValue && !loaderTemplates" class="search-result">
      {{ parseTranslation(TEMPLATES_NOT_FOUND) }} "{{ queryValue }}"
    </div>

    <div class="buttons" v-if="selectTemplateGroup.length && !loaderTemplates">
      <button class="cancel" @click="cancel()">
        {{ parseTranslation(CANCEL) }}
      </button>

      <button class="apply" @click="applyTemplate()">
        <span class="loader-apply" v-if="loader"><Loader color="#fff"/></span>

        <span v-else> {{ parseTranslation(APPLY) }} </span>
      </button>
    </div>

    <div v-if="loaderTemplates" class="loader">
      <Loader color="#000" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import Loader from '@/components/loading/Loader-3'

import * as translationTemplateGroups from './TemplateGroups.translations'

const { default: translations, ...translationKeys } = translationTemplateGroups

export default {
  name: 'TemplateGroups',
  components: { Loader },
  props: {
    selectTemplateGroup: {
      required: true,
    },

    templateCategories: {
      required: true,
    },

    loaderTemplates: {
      required: true,
    },
  },

  data() {
    return {
      translations,
      ...translationKeys,
      loader: false,
    }
  },

  computed: {
    queryValue() {
      if (this.$route.query._q === '' || this.$route.query._q) {
        return this.$route.query._q
      } else return null
    },
  },

  methods: {
    ...mapActions([
      'modalTemplate',
      'sendMessage',
      'surveyRegister',
      'executeSurveyAPICall',
    ]),

    openModal(template, index) {
      this.groupCode = template.group_code

      const contentTemplate = document.querySelector(
        `#content-template-${index}-${template.group_code}`,
      )

      const allContentTemplate = document.querySelectorAll('.content-template')

      allContentTemplate.forEach(all => {
        if (all.classList.contains('active')) all.classList.remove('active')
      })

      contentTemplate.classList.toggle('active')

      this.modalTemplate(template)
    },

    async createEmptySurvey() {
      const newSurvey = await this.executeSurveyAPICall({
        method: 'POST',
        path: 'survey',
        payload: {
          lang: this.templateCategories.lang,
          type: this.templateCategories.type,
          name: this.templateCategories.surveyName,
        },
      })

      if (!newSurvey) return

      this.sendMessage(this.translations[this.language][this.SURVEY_SAVED])

      return newSurvey.id_
    },

    async applyTemplate() {
      if (!this.groupCode || this.loader) return

      this.loader = true

      let surveyId = this.templateCategories.sid

      if (!surveyId) {
        surveyId = await this.createEmptySurvey()
      }

      if (!surveyId) {
        this.loader = false

        return
      }

      const updatedSurvey = await this.executeSurveyAPICall({
        method: 'POST',
        path: 'survey/add-templates',
        payload: {
          survey_id: surveyId,
          group_codes: [this.groupCode],
          language: this.templateCategories.lang,
        },
      })

      this.sendMessage(this.translations[this.language][this.TEMPLATE_ADDED])
      this.surveyRegister(updatedSurvey)

      window.sessionStorage.setItem('templateCategories', '')
      this.$router.push('/scheme')

      this.loader = false
    },

    cancel() {
      this.$router.push('/')
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
}

.templates {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  animation: growDown 400ms ease-in-out forwards;
  transform-origin: top center;
  > div {
    display: flex;
    flex-wrap: wrap;
    margin: 0 20px 40px;
    .content {
      width: 250px;
      padding: 10px 5px;
      cursor: pointer;
      background: transparent;
      border: none;
      outline: none;

      .content-template {
        height: 160px;
        background: $main-4;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 8px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        &:hover {
          background: $main-3;
        }
        &.active {
          border: 2px solid $blue;
        }
      }
      p {
        margin-top: 20px;
        @include tipography(18);
        text-transform: uppercase;
        text-align: center;
      }
      .light & {
        .content-template {
          background: $gray-light-4;
          &:hover {
            transition: all 0.3 ease;
            background: $gray-light-5;
          }
          &.active {
            border: 2px solid $blue;
          }
        }
        p {
          color: $gray-2;
        }
      }
    }
  }
}

.buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: 50px;
  animation: growDown 400ms ease-in-out forwards;
  transform-origin: top center;

  .apply {
    background: $main;
    @include typography1(13, 15, $gray-2, 600);
    color: $white;
    border: none;
    border-radius: 3px;
    text-transform: uppercase;
    letter-spacing: 0.2em;
    padding: 7px 20px;
    cursor: pointer;
    min-width: 105px;

    .loader-apply {
      display: flex;
      justify-content: center;
    }

    &:hover {
      transform: scale(1.02);
    }
  }

  .cancel {
    margin-right: 20px;
    background: $transparent;
    @include typography1(13, 15, $pink, 600);
    color: $pink;
    border: 1px solid $pink;
    border-radius: 3px;
    text-transform: uppercase;
    letter-spacing: 0.2em;
    margin-right: 20px;
    padding: 7px 20px;
    cursor: pointer;
    min-width: 105px;

    &:hover {
      transform: scale(1.02);
    }
  }
}

.search-result {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.loader {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

@media (max-width: 768px) {
  .buttons {
    display: flex;
    justify-content: center;
  }

  .templates {
    justify-content: center;
  }
}
</style>
